import { BASE_METHOD, fetchApi, FetchApiOrigin } from "~/common/API/baseApi";

export default class OtherService {
  static getCountries = async (limit: number = 250) => {
    const response = await fetchApi({
      origin: FetchApiOrigin.LIGHT_API_ORIGIN,
      endpoint: "/geo/countries",
      method: BASE_METHOD.GET,
      isFullScreenLoading: false,
      params: {
        limit,
      },
    });
    return response;
  };

  static getCities = async () => {
    const response = await fetchApi({
      origin: FetchApiOrigin.LIGHT_API_ORIGIN,
      endpoint: "/geo/cities",
      method: BASE_METHOD.GET,
      isFullScreenLoading: false,
    });
    return response;
  };

  static getCategories = async () => {
    const response = await fetchApi({
      origin: FetchApiOrigin.LIGHT_API_ORIGIN,
      endpoint: "/place/categories-with-place-count",
      method: BASE_METHOD.GET,
    });
    return response;
  };

  static getFilters = async () => {
    const response = await fetchApi({
      origin: FetchApiOrigin.LIGHT_API_ORIGIN,
      endpoint: "/telegram/statistic-chart",
      method: BASE_METHOD.GET,
    });
    return response;
  };

  static getMinMaxFilters = async () => {
    const response = await fetchApi({
      origin: FetchApiOrigin.LIGHT_API_ORIGIN,
      endpoint: "/place/telegram/get-mix-max-subs",
      method: BASE_METHOD.GET,
    });
    return response;
  };
}
